import _ from "lodash";
import PropTypes from "prop-types";
import { useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";

import actions from "@/actions";
import { Select } from "@/components";
import { Map } from "@/utils";

import Panel from "../base/Panel";

const FilterPanel = ({
    setFilteredFlags,
    opened,
    filteredFlags,
    selectMatches,
    countFilteredlights,
}) => {
    const prevOpenedRef = useRef(opened);

    useEffect(() => {
        if (!opened && prevOpenedRef.current) {
            setFilteredFlags([]);
        }
        prevOpenedRef.current = opened;
    }, [opened, setFilteredFlags]);

    const renderFlag = useCallback((context) => {
        const flag = context.data;
        return (
            <div {...context.innerProps}>
                <div className="flag">
                    <div
                        className={flag.icon}
                        style={
                            flag.icon === "triangle"
                                ? { borderBottomColor: flag.color }
                                : { backgroundColor: flag.color }
                        }
                    />
                    <div className="flag-label">{flag.label}</div>
                </div>
            </div>
        );
    }, []);

    return (
        <Panel title="Filter by Flags">
            <div className="filter-panel">
                <Select
                    multi
                    options={Map.Collections.flags}
                    placeholder="Filter and select one or more flags…"
                    value={filteredFlags}
                    onChange={(selectedOptions) =>
                        setFilteredFlags(selectedOptions)
                    }
                    components={{
                        Option: renderFlag,
                        MultiValueLabel: renderFlag,
                        IndicatorsContainer: () => null,
                    }}
                />
                <button
                    type="button"
                    disabled={filteredFlags.length === 0}
                    className="btn btn-primary select-matches"
                    onClick={() => selectMatches(filteredFlags)}
                >
                    Select Matches
                </button>
                <div className="counterWrapper">
                    <div className="countMatches">
                        {`${countFilteredlights} matches`}
                    </div>
                </div>
            </div>
        </Panel>
    );
};

FilterPanel.propTypes = {
    setFilteredFlags: PropTypes.func.isRequired,
    opened: PropTypes.bool,
    filteredFlags: PropTypes.array,
    selectMatches: PropTypes.func.isRequired,
    countFilteredlights: PropTypes.any,
};

const mapStateToProps = ({ map }) => {
    const count = (lights) => _.filter(lights, (o) => o.filtered).length;
    return {
        filteredFlags: map.general.filteredFlags,
        countFilteredlights: count(_.values(map.values.global.present.lights)),
    };
};
const mapDispatchToProps = {
    setFilteredFlags: actions.map.general.setFilteredFlags,
    selectMatches: actions.map.general.selectMatches,
};
export default connect(mapStateToProps, mapDispatchToProps)(FilterPanel);
